import { render, staticRenderFns } from "./GtcView.vue?vue&type=template&id=1aaf870a&scoped=true"
import script from "./GtcView.vue?vue&type=script&lang=js"
export * from "./GtcView.vue?vue&type=script&lang=js"
import style0 from "./GtcView.vue?vue&type=style&index=0&id=1aaf870a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf870a",
  null
  
)

export default component.exports